/* global $:true plyr:true */

import toast from '@vendor/pyrsmk-toast/toast';
import debug from "debug";
import { ELEMENT_SELECTOR, MODULE_NAME} from './index';


const log = debug(MODULE_NAME);

// https://github.com/appleple/modal-video
export class VideoBlockComponent {

    constructor (element, options) {
        this.element = element;
        this.$element = $(element);
        this.options = options;

        this.options.classNames = {
            modalVideo: this.options.class_modalVideo,
            modalVideoClose: this.options.class_modalVideoClose,
            modalVideoBody: this.options.class_modalVideoBody,
            modalVideoInner: this.options.class_modalVideoInner,
            modalVideoIframeWrap: this.options.class_modalVideoIframeWrap,
            modalVideoCloseBtn: this.options.class_modalVideoCloseBtn,
        };

        this.options.aria = {
            openMessage: this.options.aria_openMessage,
            dismissBtnMessage: this.options.aria_dismissBtnMessage,
        };

        toast(
            `https://cdn.jsdelivr.net/npm/modal-video@2.4.5/js/jquery-modal-video.min.js`,
            () => {
                log('construct', this.element);
                this.$element.modalVideo(this.options);
            });
    }

}

VideoBlockComponent.DEFAULTS = {
    channel: 'youtube',

    class_modalVideo: 'video-block-modal',
    class_modalVideoClose: 'video-block-modal--closing',
    class_modalVideoBody: 'video-block-modal__container',
    class_modalVideoInner: 'video-block-modal__video',
    class_modalVideoIframeWrap: 'video-block-modal__video-container',
    class_modalVideoCloseBtn: 'video-block-modal__close-button',

    aria_openMessage: 'You just openned the modal video',
    aria_dismissBtnMessage: 'Close the modal by clicking here',
};



// WEBPACK FOOTER //
// ./project/client/src/core/modules/video-blocks/component.js